module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/df78b6007d44f12f02b0eda0d4ab2819.png";